module.exports = __webpack_public_path__ + "static/img/mini_qr.371cf2f.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/mini_qr.png
// module id = KgSV
// module chunks = 1